import React, { useState } from 'react';
import { FaTachometerAlt, FaGasPump, FaUserFriends, FaCogs } from 'react-icons/fa';
import { Link } from 'react-router-dom';
import AddressModal from './AddressModal'; // <-- IMPORT NEW MODAL

const CarCard = ({ id, name, type, price, image, specs }) => {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [confirmationMsg, setConfirmationMsg] = useState(null);

  const handleOpenModal = (e) => {
    e.preventDefault();
    setIsModalOpen(true);
  };

  const handlePaymentSuccess = (msg) => {
    setConfirmationMsg(msg);
    setTimeout(() => setConfirmationMsg(null), 8000); 
  };
  
  const numericPrice = price.replace(/[^\d.]/g, ''); 
  
  // Package car data to pass through modals
  const carData = {
    carName: name,
    carPrice: numericPrice,
    carImage: image,
    carId: id,
    onPaymentSuccess: handlePaymentSuccess
  };

  return (
    <div className="bg-white rounded-lg shadow-md overflow-hidden p-4 transition-all duration-300 ease-in-out hover:scale-105 hover:shadow-[0_0_50px_10px_rgba(251,191,36,0.5)]">
      {/* Confirmation Message Display */}
      {confirmationMsg && (
          <div className="p-3 bg-green-600 text-white text-center rounded-t-lg font-semibold absolute w-full top-0 left-0 z-20">
              {confirmationMsg}
          </div>
      )}
      
      <div className="h-48 rounded-lg overflow-hidden mb-4">
        <img 
          src={image} 
          alt={name} 
          className="w-full h-full object-cover" 
        />
      </div>
      
      <div className="p-2">
        {/* ... details ... */}
        
        {/* RENT NOW BUTTON - Opens ADDRESS MODAL */}
        <button 
          onClick={handleOpenModal}
          className="mt-6 w-full block text-center bg-transparent border border-black text-black py-3 rounded-lg font-semibold hover:bg-black hover:text-white transition duration-300"
        >
          Rent Now
        </button>
        
        {/* DETAILS LINK */}
        <Link 
          to={`/details/${id}`}
          className="mt-2 w-full block text-center bg-transparent border border-black text-black py-3 rounded-lg font-semibold hover:bg-black hover:text-white transition duration-300"
        >
          View Details
        </Link>
      </div>

      {isModalOpen && (
        <AddressModal 
          carData={carData} 
          onClose={() => setIsModalOpen(false)}
        />
      )}
    </div>
  );
};

export default CarCard;